import { apiSlice } from '../apiSlice';

import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	RequestDto,
	UnitTagFilter,
	UnitTagListDTO,
} from '../DTO/exercise/unitTag.interface';

export const unitTagApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getUnitTagList: builder.query<
			SuccessResponse<Paginated<UnitTagListDTO>>,
			UnitTagFilter
		>({
			query: (body) => ({
				url: `/web/exercise/tag/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['UnitTag'],
		}),
		deleteUnitTagList: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/exercise/tag/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['UnitTag'],
		}),
		sortTag: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/exercise/tag/sort`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['UnitTag'],
		}),
		createTag: builder.mutation<SuccessResponse<any>, RequestDto>({
			query: (body) => ({
				url: `/web/exercise/tag`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['UnitTag'],
		}),
		updateTag: builder.mutation<SuccessResponse<any>, RequestDto>({
			query: (body) => ({
				url: `/web/exercise/tag`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['UnitTag'],
		}),
	}),
});

export const {
	useGetUnitTagListQuery,
	useDeleteUnitTagListMutation,
	useSortTagMutation,
	useCreateTagMutation,
	useUpdateTagMutation,
} = unitTagApiSlice;
